import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-remote-hw-folder",
  "use": "icon-soc-remote-hw-folder-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" id=\"icon-soc-remote-hw-folder\">\r\n  <path fill=\"currentColor\" d=\"M128 256h320l64 64h384v448H128V256zm64 128v320h640V384H512l-64-64H192v64z\" />\r\n  <circle cx=\"704\" cy=\"560\" r=\"96\" fill=\"currentColor\" fill-opacity=\".35\" />\r\n  <path fill=\"currentColor\" d=\"M672 528h64v96h-64zM640 576h128v32H640z\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-remote-hw-folder.svg
// module id = 7UBp
// module chunks = 546